@use '../../assets/styles/variables.scss' as vars;

.opportunity {
  border-top: solid 1px vars.$white;
  margin-top: 2rem;

  &:first-child {
    border: none;
    margin: 0;
  }
}

.volunteer-ways {
  display: flex;
  flex-direction: column;
  gap: 2rem;
  align-items: center;
  margin-top: 2rem;

  @media (min-width: 1024px) {
    flex-direction: row;
  }

  img {
    max-width: 400px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  }

  div {
    flex: 1;

    ul {
      list-style-type: disc;
      padding-left: 1.5rem;
    }
  }
}

.volunteer__cta {
  display: flex;
  flex-direction: column;
  align-items: center;
}
